(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = global || self, factory(global.slog = {}));
}(this, function (exports) { 'use strict';

    var SlogLevel;
    (function (SlogLevel) {
        SlogLevel[SlogLevel["reject"] = -2] = "reject";
        SlogLevel[SlogLevel["stringify"] = -1] = "stringify";
        SlogLevel[SlogLevel["panic"] = 0] = "panic";
        SlogLevel[SlogLevel["alert"] = 1] = "alert";
        SlogLevel[SlogLevel["crit"] = 2] = "crit";
        SlogLevel[SlogLevel["error"] = 3] = "error";
        SlogLevel[SlogLevel["warn"] = 4] = "warn";
        SlogLevel[SlogLevel["notice"] = 5] = "notice";
        SlogLevel[SlogLevel["info"] = 6] = "info";
        SlogLevel[SlogLevel["debug"] = 7] = "debug";
        SlogLevel[SlogLevel["trace"] = 8] = "trace";
    })(SlogLevel || (SlogLevel = {}));
    const contextArg = (context, a) => {
        if (typeof a !== 'object' || a === null) {
            // Just stringify the argument.
            return '' + a;
        }
        else if (a.length !== undefined) {
            // Take the value as the (anonymous) array.
            return a;
        }
        // Deconstruct the argument object.
        let valname, val;
        for (const vname of Object.keys(a)) {
            if (vname === 'format') ;
            else if (valname !== undefined || typeof a[vname] === 'function') {
                // Too many members or seems to be an active object.
                return a;
            }
            else {
                // We have at least one non-format member.
                valname = vname;
                val = JSON.stringify(a[vname], undefined, 2);
            }
        }
        if (valname === undefined) {
            // No non-format arguments.
            return a;
        }
        if (valname[0] === '_') ;
        else if (valname in context) {
            const oval = context[valname];
            if (val !== oval) {
                slog.error `Context value ${{ valname }} mismatch: ${{ val }} vs. ${{ oval }}`;
            }
        }
        else {
            context[valname] = val;
        }
        return val;
    };
    const makeSlog = (makeHandler) => {
        const doit = (level, name) => {
            const handler = makeHandler(level, name);
            function tag(contextOrTemplate, ...args) {
                if (!contextOrTemplate.raw) {
                    const c = { ...contextOrTemplate };
                    return (t, ...a) => handler(c, t, a);
                }
                // No specified context, this is the template tag.
                const context = new Map();
                const template = contextOrTemplate;
                return handler(context, template, args);
            }
            return tag;
        };
        const slog = doit(SlogLevel.stringify, 'stringify');
        slog.panic = doit(SlogLevel.panic, 'panic');
        slog.alert = doit(SlogLevel.alert, 'alert');
        slog.crit = doit(SlogLevel.crit, 'crit');
        slog.error = doit(SlogLevel.error, 'error');
        slog.reject = doit(SlogLevel.reject, 'reject');
        slog.warn = doit(SlogLevel.warn, 'warn');
        slog.notice = doit(SlogLevel.notice, 'notice');
        slog.info = doit(SlogLevel.info, 'info');
        slog.debug = doit(SlogLevel.debug, 'debug');
        slog.trace = doit(SlogLevel.trace, 'trace');
        return slog;
    };
    const defaultMakeHandler = (rawLevel, name) => {
        const level = rawLevel;
        const prefix = level < 0 ? '' : name + ': ';
        return (context, template, args) => {
            let ca;
            const reduced = args.reduce((prior, a, i) => {
                ca = contextArg(context, a);
                const last = prior[prior.length - 1];
                if (typeof ca === 'object' && ca !== undefined) {
                    prior[prior.length - 1] = last.trimRight();
                    prior.push(ca, template[i + 1].trimLeft());
                }
                else {
                    prior[prior.length - 1] = last + String(ca) + template[i + 1];
                }
                return prior;
            }, [prefix + template[0]]);
            if (level === SlogLevel.reject) {
                // Just return a promise rejection.
                return Promise.reject(reduced.join(' '));
            }
            else if (level < 0) {
                // Just stringify.
                return reduced.join(' ');
            }
            if (level >= SlogLevel.warn) {
                // Use console.error to provide an inspectable result in the
                // browser without polluting stdout on Node.
                console.error(...reduced);
            }
            else {
                // Record a location, too.
                const at0 = new Error().stack;
                console.error(...reduced, at0);
            }
            if (level <= SlogLevel.panic && typeof process !== 'undefined') {
                // Exit the process.
                process.exit(99);
            }
            else if (level <= SlogLevel.alert && typeof alert !== 'undefined') {
                alert(reduced.join(' '));
            }
            else if (level <= SlogLevel.error) {
                // Throw an exception without revealing stack.
                throw reduced.join(' ');
            }
            // Return nothing.
        };
    };
    const slog = makeSlog(defaultMakeHandler);

    exports.contextArg = contextArg;
    exports.defaultMakeHandler = defaultMakeHandler;
    exports.makeSlog = makeSlog;
    exports.slog = slog;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
